


;

import { convertLocale } from '@/utils/i18nUtils';

/**
 * This is a mixin component to carry out locale / translation related operations
 *
 * - Methods
 * @property {Function} initLocale Initialize locale
 * @property {Function} changeLocale Function to change locale
 * @property {Function} convertLocale Function to convert locale format (eg. between zhHant & zh_HK)
 *
 * - Computed
 * @property {Function} availableLocales Get available locales in this application (Installed / Initialized)
 * @property {Function} currentLocale Get current locale (in 'vuetify' format)
 *
 * @see https://vuetifyjs.com/en/features/internationalization/
 * @see https://kazupon.github.io/vue-i18n/
 * @see https://vee-validate.logaretm.com/v3/guide/localization.html
 *
 * @author Tin Ley Ter <leyter.tin@orbitmy.com>
 * @since 2022/07/20
 */
export default {
  methods: {
    /**
     * Function to Change Locale
     * @param {String} locale The target locale to change into (any format that is in defined {@link vuetify const})
     * @param {Boolean} refresh Whether to force refresh the page [Default: `false`]
     */
    async changeLocale(locale, refresh = false) {
      await $this.$api.postData({
        data: [
          {
            api: 'AuthService.updateUserLanguageUsed',
            input: { locale }
          }
        ]
      })
      this.$router.go()
    },
    /**
     * Function to Convert Locale Format (eg. between zhHant & zh_HK)
     * @param {String} locale The source locale to change into (any format that is defined in {@link vuetify const})
     * @param {String} to The target locale format to convert to
     * - Available values: **['vuetify', 'vee', 'bcp47']**
     * @return {String} The converted locale language code
     */
    convertLocale(locale, to) {
      return convertLocale(locale, to)
    }
  },
  computed: {
    /**
     * Get Available Locales In This Application
     * @return {Array} List of available locales [vuetify {@link https://vuetifyjs.com/en/features/internationalization/ format}]
     */
    ...require('vuex').mapState('Auth', ['availableLocales']),
    /**
     * Get Current Locale
     * @return {String} Current Locale [vuetify {@link https://vuetifyjs.com/en/features/internationalization/ format}]
     */
    currentLocale() {
      return this.$root.$i18n.locale
    }
  }
}
